import { Component } from '@angular/core';
import { NavbarComponent } from "../../../partials/navbar/navbar.component";
import { FooterComponent } from "../../../partials/footer/footer.component";
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-electric-vehicle',
  standalone: true,
  imports: [NavbarComponent, FooterComponent],
  templateUrl: './electric-vehicle.component.html',
  styleUrl: './electric-vehicle.component.css'
})
export class ElectricVehicleComponent {
  texts:any;

  constructor(private langServ:LanguageService){
    this.texts = langServ.getWebisteTexts().electric_vehicule;
  }


}
